import PageFlow from '../../components/PageFlow'
import RegisterMFACompleteStep from '../../components/RegisterMFACompleteStep'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../../constants/mfa.setup.steps'
import { RegisterStep, StartRegistrationStep } from './steps'

const DEFAULT_LOCATION = { state: { isFromSettings: false } }

const SetupMFAWebAuthn = ({
  location = DEFAULT_LOCATION,
  step,
  registrationData,
  credential,
  onFinishRegistration,
  rootPath,
  settingsPath,
  onComplete,
  ...rest
}) => {
  const { isFromSettings } = location.state || {}

  const finishRegistration = () =>
    onFinishRegistration({
      requestId: registrationData.requestId,
      credential,
    })

  const stepProps = {
    ...rest,
    location,
    step,
    registrationData,
    credential,
    onFinishRegistration,
  }

  return (
    <PageFlow currentStep={step}>
      <PageFlow.Step name={START_REGISTRATION}>
        <StartRegistrationStep {...stepProps} />
      </PageFlow.Step>
      <PageFlow.Step name={REGISTER}>
        <RegisterStep
          {...stepProps}
          isValid={!!credential}
          onFinishRegistration={finishRegistration}
        />
      </PageFlow.Step>
      <PageFlow.Step name={REGISTRATION_COMPLETE}>
        <RegisterMFACompleteStep
          isFromSettings={isFromSettings}
          rootPath={rootPath}
          settingsPath={settingsPath}
          onComplete={onComplete}
        />
      </PageFlow.Step>
    </PageFlow>
  )
}

export default SetupMFAWebAuthn
